import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../../fnx/showError";
var useToastOnError = function (error, setSeeToast) {
    var t = useTranslation().t;
    useEffect(function () {
        if (error)
            showErrorToast(error, setSeeToast, t);
    }, [error]);
};
export var usePlanCreationErrorHandling = function (_a) {
    var errorCoverTypes = _a.errorCoverTypes, errorPaymentModes = _a.errorPaymentModes, errorPlan = _a.errorPlan, errorCreatePlan = _a.errorCreatePlan, errorUpdatePlan = _a.errorUpdatePlan, errorBenefits = _a.errorBenefits, errorCreateBenefit = _a.errorCreateBenefit, errorUpdateBenefit = _a.errorUpdateBenefit, errorDeleteBenefit = _a.errorDeleteBenefit, setSeeToast = _a.setSeeToast;
    useToastOnError(errorCoverTypes, setSeeToast);
    useToastOnError(errorPaymentModes, setSeeToast);
    useToastOnError(errorPlan, setSeeToast);
    useToastOnError(errorCreatePlan, setSeeToast);
    useToastOnError(errorUpdatePlan, setSeeToast);
    useToastOnError(errorBenefits, setSeeToast);
    useToastOnError(errorCreateBenefit, setSeeToast);
    useToastOnError(errorUpdateBenefit, setSeeToast);
    useToastOnError(errorDeleteBenefit, setSeeToast);
};
